export default {
	init() {
		const parents = document.querySelectorAll('.js-navigation-parent');
		const menuToggles = document.querySelectorAll('.js-closeable-header-toggle')
		const menuHideableSections = document.querySelectorAll('.js-closeable-header-section')

		parents.forEach(parent => {

			parent.addEventListener('click', event => {
				var targetName = parent.dataset.target
				const container = parent.closest('.c-desktop-navigation')
				const targetElem = container.querySelector(`[data-parent="${targetName}"]`)
				const activeElems = container.querySelectorAll('.c-navigation-menu__children.active')

				parents.forEach(innerParent => {
					innerParent.classList.remove('active')
				})

				parent.classList.add('active')

				if (activeElems) {
					activeElems.forEach(activeElem => {
						activeElem.classList.remove('active')
					})
				}

				targetElem.classList.add('active')

				event.preventDefault();
			})
		})

		menuToggles.forEach(menuToggle => {
			menuToggle.addEventListener('click', event => {
				menuHideableSections.forEach(menuHideableSection => {
					menuHideableSection.classList.toggle('closed');
				})
				event.preventDefault()
			})
		})
	}
}
